var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "trusted-ratings mt-4" },
    [
      _vm.singleReview
        ? [
            _c("div", { staticClass: "trusted-top" }, [
              _c("div", { staticClass: "comment-container" }, [
                _c("div", [
                  _c("blockquote", { staticClass: "fade-rating" }, [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.singleReview.review.comment),
                      },
                    }),
                    _vm._v(" "),
                    _c("cite", [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.singleReview.orderAddresses[0].name1
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "font-weight-normal" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$translate(
                                "Servershop5::Template.TrustedshopsFrom"
                              )
                            ) +
                            " "
                        ),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.singleReview.orderAddresses[0].town
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "trusted-bottom" },
              [
                _c("lazy-img", {
                  staticClass: "mr-2",
                  attrs: {
                    "image-url":
                      "/layout/od_servershop24_v1_10/images/trusted-shops.png",
                    alt: "Trusted Shops",
                    title: "Trusted Shops",
                  },
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$translate("Servershop5::Template.TrustedshopsNote")
                    ) +
                    "  / "
                ),
                _c("span", [_vm._v("5.00")]),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$translate("Servershop5::Template.TrustedshopsFrom")
                    ) +
                    " "
                ),
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$translate(
                          "Servershop5::Template.TrustedshopsTotalRatings"
                        )
                      ) +
                      " "
                  ),
                ]),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$translate("Servershop5::Template.Bewertungen")
                    ) +
                    "\n        "
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }